import React from 'react'
import soldmap from './images/soldmap.png'
import { VscSearch } from 'react-icons/vsc'
import { Link } from 'react-router-dom'

const Track = () => {
    return (
        <>
            <div className="">
                <div className="py-5">
                    <div className="py-10 lg:mx-0 md:mx-10 mx-5">
                        <h1 className='text-[#004A8B] text-[2.6rem]  lg:ml-[22rem] high'>Track record</h1>
                        <div className=" border-b-[.4rem] border-b-[#B5D1B3] lg:ml-[22rem] py-1  w-[4rem]"></div>

                    </div>
                    
                    <div className="md:lg:pl-[19.5rem] pb-[7rem]">
                        <div className="md:mx-10   w-full md:w-[70%]">
                            <p className='tracking-wider leading-8 text-[#004A8B] text-[1.2rem] md:text-[1.5rem] high md:mx-0 mx-5'>LAWD has an outstanding track record of connecting premium buyers with specialist Australian real estate across development sites, institutional grade assets, corporate farms, downstream processing facilities, family farms and lifestyle properties.</p>
                        </div>
                    </div>
                </div>

                <div className=" bg-gray-100 mx-3 md:mx-8 py-10">
                    <div className="container md:mx-10">
                        <div class="grid grid-cols-12 mx-30">


                            <div class="md:col-span-3 col-span-12 lg:ml-5 px-5">

                                <div className="lg:w-[90%] ">
                                    <select name="" id="" className='py-3 px-2 w-full text-[13px] tracking-wider border-none border-gray-200 focus:outline-none' >
                                        <option value="" className=''>FOR SALE</option>
                                        <option value="">SOLD</option>
                                    </select>
                                </div>

                                <div className=" my-[1.2rem] md:w-[90%]  ">
                                    <select name="" id="" className='py-3 px-2 w-full text-[13px]  border-none border-gray-200 focus:outline-none' >
                                        <option value="">STATE</option>
                                        <option value="">ACT</option>
                                        <option value="">NSW</option>
                                        <option value="">NT</option>
                                        <option value="">QLD</option>
                                        <option value="">TAS</option>
                                        <option value="">VIC</option>
                                        <option value="">WA</option>
                                    </select>
                                </div>
                                <div className=" md:w-[90%]  my-[.7rem]">
                                    <input type="text" placeholder='SUBRUB' className='py-3 px-2 w-full tracking-wider text-[13px] placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className="md:w-[90%]  my-[1.2rem] ">
                                    <select name="" id="" className='py-3 px-2 w-full text-[13px] tracking-widest border-none border-gray-200 focus:outline-none' >
                                        <option value="" className=''>PROPERTY TYPE</option>
                                        <option value="">Cotton</option>
                                        <option value="">Cropy</option>
                                        <option value="">Dairy</option>
                                        <option value="">Development</option>
                                        <option value="">Horticulture</option>
                                        <option value="">LiveStocks</option>
                                    </select>
                                </div>

                                <div className="md:w-[90%]    my-[.7rem] ">
                                    <input type="text" placeholder='MIN PRICE' className=' py-3 px-2 w-full tracking-widest text-[13px]  placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className=" md:w-[90%]  py-2">
                                    <input type="text" placeholder='MAX PRICE' className='py-3 px-2 w-full tracking-widest text-[13px]   placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className=" md:w-[90%]  my-[.7rem]">
                                    <input type="text" placeholder='MIN AREA' className='py-3 px-2 w-full tracking-widest text-[13px]   placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className=" md:w-[90%] py-2">
                                    <input type="text" placeholder='MAX AREA' className='py-3 px-2 w-full tracking-widest text-[13px]    placeholder-black focus:outline-none focus:border-none' />
                                </div>

                                <div className="bg-[#004A8B] hover:bg-[#B6D0B3] text-white md:w-[90%]  text-[13px] font-black my-2">
                                    <button className='py-2  px-2'>
                                        <Link to='/Search' className='flex tracking-widest text-[13px]'><span className='py-1'>SEARCH NOW </span><VscSearch className='text-[1.7rem] ml-[10rem] md:ml-[5rem]' /></Link>
                                    </button>
                                </div>

                            </div>

                            <div class="md:col-span-9 col-span-12">
                                <div className="md:mx-0 mx-2">
                                    <img src={soldmap} alt="map" className='md:h-[87vh] h-[60vh] md:w-[94%] w-[100%] hover:opacity-70 hover:bg-gray-200 transition duration-500 ease-in-out sm:hover:bg-transparent sm:hover:opacity-100' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Track